import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Tab } from '../../../../components/Tab';
import { PartnersTab } from '../../components/PartnersTab';
import { PromotionsTab } from '../../components/PromotionsTab';
import { useSelector } from 'react-redux';
import { setUsersPermissions } from '../../../../utils/setUsersPermissions';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';
import { PERMISSIONS } from '../../../../constants/variables';
import { CustomModal } from '../../../../components/CustomModal';
import { PackagesTab } from '../../components/PackagesTab';

const PARTNERS = 'PARTNERS';
const PROMOTIONS = 'PROMOTIONS'; // Партнёрские акции
const PACKAGES = 'PACKAGES'; // Пакеты

export const Partners = () => {
  const [typeTab, setTypeTab] = useState(localStorage.getItem('partnersTab') || PARTNERS);
  const [messageModal, setModalMessage] = useState('');

  const { userPermissions, currentUsersPermissions } = useSelector(
    (state) => state.userPermissions
  );
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  useEffect(() => {
    const message = localStorage.getItem('promotionMessage');
    if (message) setModalMessage(message);
  }, []);

  if (
    !visibleBySectionPermission(
      permissions,
      [
        PERMISSIONS.PARTNERS.listPartners.value,
        PERMISSIONS.PARTNERS.createPartners.value,
        PERMISSIONS.PARTNER.listPartnerPromotions.value,
        PERMISSIONS.PARTNER.createPartnerPromotions.value
      ],
      'or'
    )
  )
    return null;

  return (
    <Box>
      <Typography mb="24px" variant="h1" sx={{ color: 'text.primary' }} component="h1">
        Партнёры
      </Typography>

      <Box display="flex" justifyContent="space-between">
        <Box display="flex">
          <Tab
            label="Партнёры"
            setTypeTable={() => setTypeTab(PARTNERS)}
            typeCurrent={typeTab}
            typeDefault={PARTNERS}
          />
          <Tab
            label="Партнёрские акции"
            setTypeTable={() => setTypeTab(PROMOTIONS)}
            typeCurrent={typeTab}
            typeDefault={PROMOTIONS}
          />
          <Tab
            label="Пакеты"
            setTypeTable={() => setTypeTab(PACKAGES)}
            typeCurrent={typeTab}
            typeDefault={PACKAGES}
          />
        </Box>
      </Box>

      {typeTab === PARTNERS ? (
        <PartnersTab />
      ) : typeTab === PROMOTIONS ? (
        <PromotionsTab />
      ) : (
        <PackagesTab />
      )}
      <CustomModal
        opened={!!messageModal}
        modalClose={() => {
          localStorage.removeItem('promotionMessage');
          setModalMessage('');
        }}
        withoutSubmit
        text={messageModal}
        cancelBtnName="Отмена"
        data-testid="Warning Modal"
      />
    </Box>
  );
};
